import React from "react";
import { EventButton, CountdownTimer } from "../common";

const ResultWrong = ({ cooldownUntil, onRetry, remainingSlots }) => {
  const isCooldown = cooldownUntil && new Date(cooldownUntil) > new Date();
  const canRetry = remainingSlots > 0;

  return (
    <div className="newyear-result newyear-result--wrong">
      <div className="newyear-result__icon">
        <span className="newyear-result__emoji">
          &#128532;
        </span>
      </div>

      <h2 className="newyear-result__title">오답입니다</h2>
      <p className="newyear-result__message">
        아쉽지만 정답이 아닙니다.
      </p>

      {canRetry ? (
        <>
          <p className="newyear-result__sub-message">
            다시 도전해보세요!
          </p>

          {isCooldown && (
            <div className="newyear-result__cooldown">
              <CountdownTimer
                deadline={cooldownUntil}
                label="재응모 가능까지"
                onExpire={onRetry}
              />
            </div>
          )}

          <div className="newyear-result__actions">
            <EventButton
              variant="primary"
              size="large"
              fullWidth
              onClick={onRetry}
              disabled={isCooldown}
            >
              {isCooldown ? "대기 중..." : "다시 도전하기"}
            </EventButton>
          </div>
        </>
      ) : (
        <p className="newyear-result__sub-message">
          안타깝게도 선착순 마감되었습니다.
        </p>
      )}
    </div>
  );
};

export default ResultWrong;
